<template>
    <div>
        
        
        <!-- Modal Dialog -->
        <RdnummerModal />
    </div>
</template>

<script setup>

import RdnummerModal from '@/components/general/rdnummer_modal.vue';
</script>